'use client';

import { usePathname, useRouter } from 'next/navigation';

export default function ResetButton() {
  const router = useRouter();
  const pathname = usePathname();

  return (
    <button
      onClick={() => {
        router.push(pathname);
        router.refresh();
      }}
    >
      start over
    </button>
  );
}
